<section>
  <div class="documento-aditivo-container">
    <ng-container>
      <div class="header" style="justify-content: space-around">
        <div class="logo-operadora">
          <img [src]="operadoraVM?.logo" alt="" class="logo-img" />
        </div>
        <div class="dados-operadora">
          <div>
            <strong class="mr-1">Operadora:</strong>
            {{ operadoraVM?.nome }}
          </div>
          <div>
            <strong class="mr-1">CNPJ:</strong>
            {{ operadoraVM?.cnpj | cnpj }}
          </div>
          <div>
            <strong class="mr-1">Nº de registro na ANS:</strong>
            {{ operadoraVM?.registroAns }}
          </div>
          <div>
            <strong class="mr-1">Site:</strong>
            {{ operadoraVM?.site }}
          </div>
          <div *ngIf="operadoraVM?.telefone">
            <strong class="mr-1">Tel.:</strong>
            {{ operadoraVM?.telefone }}
          </div>
        </div>
      </div>
    </ng-container>

    <h3 class="titulo mt-1 mb-1 bold-preto-700">Manual de Orientação para Contratação de Planos de Saúde</h3>
    <h4 class="titulo">
      <strong>Diferença entre planos individuais e coletivos</strong>
    </h4>

    <p class="mb-2 alinhamento-texto-mobile">
      Os planos com contratação individual ou familiar são aqueles contratados diretamente da operadora de plano de
      saúde: é o próprio beneficiário quem escolhe as características do plano a ser contratado.
    </p>
    <p class="mb-1 alinhamento-texto-mobile">
      Os planos com contratação coletiva são aqueles em que o beneficiário ingressa no plano de saúde contratado por uma
      empresa ou órgão público (coletivo empresarial); associação profissional, sindicato ou entidade assemelhada
      (coletivo por adesão). Nos planos coletivos é uma representante dessas pessoas jurídicas contratantes, com a
      participação ou não de uma administradora de benefícios, que negocia e define as características do plano a ser
      contratado. Assim, é importante que o beneficiário antes de vincular-se a um plano coletivo, em especial por
      adesão, avalie a compatibilidade entre os seus interesses e os interesses da pessoa jurídica contratante.
    </p>

    <h4 class="titulo">
      <strong>Aspectos a serem observados na contratação ou ingresso em um plano de saúde</strong>
    </h4>

    <div class="tabela-comparativa">
      <div class="coluna estilo-coluna">
        <div class="titulo-coluna" style="font-weight: 400">
          <strong>CARÊNCIA</strong>
        </div>
      </div>
      <div class="coluna" style="padding: 0px; background: #ccc; border-radius: 0px">
        <div class="titulo-coluna p-1" style="background: #666; color: #fff; font-weight: 400">
          <strong>PLANOS INDIVIDUAIS OU FAMILIARES</strong>
        </div>
        <div class="texto p-1">
          <p class="mb-1">
            É permitida a exigência de cumprimento de período de carência nos prazos máximos estabelecidos pela Lei nº
            9.656/1998: 24h para urgência e emergencia, até 300 dias para o parto a termo e até 180 dias para demais
            procedimentos.
          </p>
          <br />
          <p class="mb-1">
            Sendo constatado no ato da contratação que o beneficiário tem conhecimento de doença ou lesão preexistente
            (DLP), conforme declaração de saúde, perícia médica ou entrevista qualificada e Carta de Orientação ao
            Beneficiário de entrega obrigatória, a operadora poderá oferecer cobertura total, após cumpridas eventuais
            carências, sem qualquer ônus adicional para o beneficiário.
          </p>
        </div>
      </div>
      <div class="coluna" style="padding: 0px; border-radius: 0px">
        <div class="titulo-coluna p-1" style="background: #ccc; padding-left: 1rem">
          <strong>PLANOS COLETIVOS</strong>
        </div>
        <div class="subtitulo ml-1 mr-1" style="background: #ccc; padding-left: 1rem">
          <strong>Coletivo Empresarial</strong>
        </div>
        <div class="texto p-1">
          <p class="mb-1">
            <strong>Com 30 participantes ou mais:</strong>
            Não é permitida a exigência de cumprimento de carência desde que o beneficiário formalize o pedido de
            ingresso em até 30 dias da celebração do contrato coletivo ou de sua vinculação à pessoa jurídica
            contratante.
          </p>

          <p class="mb-1">
            <strong>Com menos de 30 participantes:</strong>
            É permitida a exigência de cumprimento de carência nos mesmos prazos estabelecidos pela lei.
          </p>
        </div>

        <div class="bloco-sem-quebra nova-pagina">
          <div class="subtitulo ml-1 mr-1" style="background: #ccc; padding-left: 1rem">
            <strong>Coletivo por Adesão B</strong>
          </div>
          <div class="texto p-1">
            <p>
              Não é permitida a exigência de cumprimento de carência desde que o beneficiário ingresse no plano em até
              trinta dias da celebração do contrato firmado entre a pessoa jurídica contratante e a operadora de plano
              de saúde. A cada aniversário do contrato será permitida a adesão de novos beneficiários sem o cumprimento
              de carências, desde que: (1) os mesmos tenham se vinculado a pessoa jurídica contratante após 30 dias da
              data de celebração do contrato e (2) tenham formalizado a proposta de adesão até 30 dias da data de
              aniversário do contrato.
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="tabela-comparativa" style="margin-top: 10px">
      <div class="coluna estilo-coluna">
        <div class="titulo-coluna" style="font-weight: 400">
          <strong>COBERTURA PARCIAL TEMPORÁRIA (CPT)</strong>
        </div>
      </div>

      <div class="coluna" style="background: #ccc; padding: 0px; border-radius: 0px">
        <div class="texto p-1">
          <p>
            Sendo constatado no ato da contratação que o beneficiário tem conhecimento de doença ou lesão preexistente
            (DLP), conforme declaração de saúde, perícia médica ou entrevista qualificada e Carta de Orientação ao
            Beneficiário de entrega obrigatória, a operadora poderá oferecer cobertura total, após cumpridas eventuais
            carências, sem qualquer ônus adicional para o beneficiário.
          </p>
          <p>
            Caso a operadora opte pelo não oferecimento de cobertura total, deverá neste momento oferecer a Cobertura
            Parcial Temporária (CPT) que é a suspensão, por até 24 meses, das coberturas para procedimentos de alta
            complexidade, internações cirúrgicas ou em alta tecnologia, relacionados exclusivamente a DLP declarada.
            Como alternativa a CPT é facultado a operadora oferecer o Agravo, que é um acréscimo no valor da mensalidade
            para no plano privado de assistência à saúde para que o mesmo tenha acesso regular à cobertura total, desde
            que cumpridas as eventuais carências. A operadora de planos de saúde não pode negar a cobertura de
            procedimentos relacionados a DLP não declaradas pelo beneficiário antes do julgamento de processo
            administrativo na forma prevista pela RN 162/2007.
          </p>
        </div>
      </div>
      <div class="coluna" style="padding: 0px; border-radius: 0px">
        <div class="subtitulo ml-1 mr-1" style="background: #ccc; padding-left: 1rem">
          <strong>Coletivo Empresarial</strong>
        </div>
        <div class="texto p-1">
          <p>
            <strong>Com 30 participantes ou mais:</strong>
            Não é permitida a aplicação de Cobertura Parcial Temporária (CPT) ou Agravo, desde que o beneficiário
            formalize o pedido de ingresso em até 30 dias da celebração do contrato coletivo ou de sua vinculação à
            pessoa jurídica contratante.
            <br />
            <br />
          </p>
          <p>
            <strong>Com menos de 30 participantes:</strong>
            É permitida a exigência de Cobertura Parcial Temporária (CPT) ou Agravo.
          </p>
        </div>
        <div class="subtitulo ml-1 mr-1" style="background: #ccc; padding-left: 1rem">
          <strong>Coletivo por Adesão</strong>
        </div>
        <div class="texto p-1">
          <p>
            É permitida a aplicação de Cobertura Parcial Temporária (CPT) ou Agravo, independente do número de
            participantes.
          </p>
        </div>
      </div>
    </div>
    <div class="tabela-comparativa" style="margin-top: 10px">
      <div class="coluna estilo-coluna">
        <div class="titulo-coluna" style="font-weight: 400">
          <strong>MECANISMO DE COMUNICAÇÃO</strong>
        </div>
      </div>
      <div class="coluna" style="padding: 0px; border-radius: 0px">
        <div style="background: #fafafa; padding: 18px 16px 16px 16px">
          <div class="texto">
            É importante que o beneficiário verifique: (1) se o plano a ser contratado possuí coparticipação e/ou
            franquia. Em caso positivo, é obrigatório constar no contrato quais os serviços de saúde e como será a sua
            participação financeira. (2) Como é o acesso aos serviços de saúde, no plano que deseja contratar. Exigência
            de perícia por profissionais de saúde, autorização administrativa prévia e/ou direcionamento a prestadores
            só são permitidas se houver previsão no contrato.
          </div>
        </div>
      </div>
    </div>
    <div class="tabela-comparativa" style="margin-top: 10px">
      <div class="coluna estilo-coluna">
        <div class="titulo-coluna" style="font-weight: 400">
          <strong>REAJUSTE</strong>
        </div>
      </div>
      <div style="background: #fafafa">
        <div class="coluna" style="padding: 0px; border-radius: 0px">
          <div style="background: #fafafa; padding: 18px 16px 16px 16px">
            <div class="texto">
              <p>
                Os planos individuais ou familiares precisam de autorização prévia das ANS para aplicação de reajuste
                anual, exceto para os de cobertura exclusivamente odontológica que devem ter cláusula clara elegendo um
                índice de preços divulgado por instituição externa. A variação da mensalidade por mudança de faixa
                etária é o aumento decorrente da alteração de idade do beneficiário, segundo faixas e percentuais de
                variação dispostos em contrato e atendendo a RN nº 63/2003. Os planos coletivos não precisam de
                autorização prévia da ANS para aplicação de reajuste anual. Assim, nos reajustes aplicados às
                mensalidades dos contratos coletivos, prevalecerá o disposto no contrato ou índice resultante de
                negociação entre as partes contratantes (operadora de planos de saúde e pessoa jurídica), devendo a
                operadora, obrigatoriamente, comunicar os reajustes à ANS. O beneficiário deverá ficar atento à
                periodicidade do reajuste que não poderá ser inferior a 12 meses, que serão contados da celebração do
                contrato ou do último reajuste e não do ingresso do beneficiário ao plano. Embora não haja a necessidade
                de prévia autorização da ANS, esta faz um monitoramento dos reajustes anuais aplicados nos contratos
                coletivos. A variação da mensalidade por mudança de faixa etária é o aumento decorrente da alteração de
                idade do beneficiário, segundo faixas e percentuais de variação dispostos em contrato e atendendo a RN
                nº 63/2003.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="tabela-comparativa" style="margin-top: 10px">
      <div class="coluna estilo-coluna">
        <div class="titulo-coluna" style="font-weight: 400">
          <strong>ALTERAÇÕES NA REDE ASSISTENCIAL DO PLANO</strong>
        </div>
      </div>

      <div style="background: #ccc">
        <div class="texto p-1">
          Alterações na rede de prestadores de serviço devem ser informadas pela operadora, inclusive as inclusões. No
          caso de redimensionamento por redução de prestador hospitalar, a alteração necessita ser autorizada pela ANS
          antes da comunicação aos beneficiários. Esta comunicação deve observar 30 dias de antecedência no caso de
          prestadores hospitalares para que a equivalência seja analisada pela ANS.
        </div>
      </div>
    </div>
    <div class="tabela-comparativa" style="margin-top: 10px">
      <div class="coluna estilo-coluna">
        <div class="titulo-coluna" style="font-weight: 400">
          <strong>VIGÊNCIA</strong>
        </div>
      </div>
      <div class="coluna" style="background: #ccc; padding: 0px; border-radius: 0px">
        <div class="texto p-1">
          <p>A vigência mínima de contrato individual ou familiar é de 12 meses com renovação automática</p>
        </div>
      </div>
      <div class="coluna" style="padding: 0px; border-radius: 0px">
        <div class="texto p-1">
          <p>A vigência mínima do contrato coletivo é negociada e tem renovação automática.</p>
        </div>
      </div>
    </div>
    <div class="tabela-comparativa" style="margin-top: 10px">
      <div class="coluna estilo-coluna">
        <div class="titulo-coluna" style="font-weight: 400">
          <strong>REGRAS DE RESCISÃO E/OU SUSPENSÃO</strong>
        </div>
      </div>

      <div style="background: #fafafa">
        <div class="texto p-1">
          <p class="mb-1">
            Nos planos individuais ou familiares a rescisão ou suspensão contratual unilateral por parte da Operadora
            somente pode ocorrer em duas hipóteses: por fraude; e/ou por não pagamento da mensalidade por período
            superior a sessenta dias, consecutivos ou não, nos últimos doze meses de vigência do contrato, desde que o
            beneficiário seja comprovadamente notificado até o 50º dia de inadimplência. Nos planos coletivos as regras
            para rescisão ou suspensão contratual unilateral são negociadas entre a pessoa jurídica contratante e a
            operadora de plano de saúde. É importante que o beneficiário fique atento às regras estabelecidas no seu
            contrato.
          </p>
          <p>
            A rescisão unilateral imotivada, por qualquer das partes, somente poderá ocorrer após a vigência do período
            de 12 meses e mediante prévia notificação da outra parte com antecedência mínima de 60 dias. Na vigência do
            contrato e sem anuência da pessoa jurídica contratante, a operadora só pode excluir ou suspender assistência
            à saúde do beneficiário em caso de fraude ou perda do vínculo de titular ou de dependência.
          </p>
        </div>
      </div>
    </div>
    <div>
      <div class="subtitulo">
        <strong>Perda de condição de beneficiário nos planos coletivos</strong>
      </div>
      <p class="alinhamento-texto-mobile">
        Nos planos coletivos, os beneficiários titulares e seus dependentes podem ser excluídos do plano de saúde, que
        continua vigente, quando perdem o vínculo com a pessoa jurídica contratante, ou seja, com o sindicato;
        associação profissional ou congênere; órgão público ou empresa.
      </p>
      <div class="subtitulo">
        <strong>Direitos dos artigos 30 e 31, da Lei nº 9656/1998, nos planos coletivos empresariais</strong>
      </div>
      <p class="mb-1 alinhamento-texto-mobile">
        Nos planos coletivos empresariais em que há participação financeira do beneficiário no pagamento da mensalidade,
        regular e não vinculada à co-participação em eventos, é assegurado ao beneficiário o direito de permanência
        neste plano coletivo no caso de demissão sem justa causa ou aposentadoria. No caso de morte do titular demitido
        ou aposentado em gozo do benefício decorrente dos artigos 30 e 31, é assegurada a permanência do grupo familiar.
      </p>
      <p class="alinhamento-texto-mobile">
        O beneficiário tem um prazo máximo de 30 dias, após seu desligamento, para se manifestar junto à empresa/órgão
        público, com o qual mantinha vínculo empregatício ou estatutário, sobre sua vontade de permanecer no plano de
        saúde. O beneficiário assume integralmente o pagamento da mensalidade quando opta pela permanência. O período de
        manutenção da condição de beneficiário do plano é de 6 meses no mínimo, e proporcional ao período em que o mesmo
        permaneceu vinculado e contribuindo para o plano de saúde como empregado ou servidor. Salientamos que o
        beneficiário perde o direito de permanência no plano de saúde do seu ex-empregador ou órgão público quando da
        sua admissão em um novo emprego ou cargo.
      </p>
    </div>
  </div>
</section>

<section class="nova-pagina">
  <div class="dashed-line"></div>

  <div class="documento-aditivo-container nova-pagina">
    <h3
      class="titulo text-center bold-preto-700"
      style="margin-top: -5px !important; padding: 0.5rem; background: black; color: #fff; border-radius: 10px">
      MANUAL DE ORIENTAÇÃO PARA CONTRATAÇÃO DE PLANO DE SAÚDE
    </h3>
    <h4 class="titulo">
      <strong>
        Direito de migrar para plano individual ou familiar aproveitando carência do plano coletivo empresarial
      </strong>
    </h4>

    <p class="text-justify">
      Os beneficiários de planos coletivos empresariais que tiverem o benefício de plano de saúde extinto, terão o
      direito de se vincular a um plano da mesma operadora com contratação individual ou familiar, sem a necessidade de
      cumprimento de novos prazos de carências. Essa prerrogativa não se aplica aos planos de autogestões. Acondição
      para exercer esse direito é que a operadora comercialize plano individual ou familiar. O beneficiário tem um prazo
      máximo de 30 dias, após a extinção do benefício, para contratar, junto à operadora, o plano individual ou
      familiar. Este direito não existe caso tenha havido apenas a troca de operadora por parte do contratante (órgão
      público ou empresa).
    </p>
    <h4 class="subtitulo">Cobertura e segmentação assistencial</h4>
    <p class="mb-1 text-justify">
      Define o tipo de assistência à qual o beneficiário terá direito. Os planos podem ter assistência ambulatorial,
      obstétrica e odontológica. Essas assistências à saúde isoladas ou combinadas definem a segmentação assistencial do
      plano de saúde a ser contratado pelo beneficiário.
    </p>
    <p class="text-justify">
      A lei nº 9.656/1998 definiu como referência o plano com assistência ambulatorial, hospitalar, obstetrícia e
      urgência/emergência integral após 24h, em acomodação padrão enfermaria. O contrato pode prever coberturas mais
      amplas do que as exigidas pela legislação, mas as exclusões devem ser limitadas às previstas na Lei nº 9.656/1998.
      A cobertura para acidente de trabalho ou doença profissional em planos coletivos empresariais é adicional e
      depende de contratação específica.
    </p>
    <p class=" ">
      A cobertura para acidente de trabalho ou doença profissional em planos coletivos empresariais é adicional e
      depende de contratação específica.
    </p>
    <h4 class="mt-1 subtitulo">Abrangência geográfica</h4>
    <p class="alinhamento-texto-mobile">
      Aponta para o beneficiário a área em que a operadora de plano de saúde se compromete a garantir todas as
      coberturas de assistência à saúde contratadas. Abrangência geográfica pode ser nacional, estadual, grupo de
      estados, municipal ou grupo de municípios.
    </p>

    <h4 class="subtitulo">Área de atuação</h4>
    <p class="alinhamento-texto-mobile">
      É a especificação nominal do(s) estado(s) ou município(s) que compõem as áreas de abrangência estadual, grupo de
      estados, grupo de municípios ou municipa.
    </p>
    <p class="text-justify">
      É importante que o beneficiário fique atento à esta informação, uma vez que as especificações da área de
      abrangência e da área de atuação do plano, obrigatoriamente, devem constar no contrato de forma clara.
    </p>

    <h4 class="subtitulo">Administradora de Benefícios</h4>
    <p class="text-justify">
      Quando houver participação da Administradora de Benefícios na contratação do plano coletivo empresarial, a
      verificação do número de participantes para fins de carência ou CPT considerará a totalidade de participantes
      eventualmente já eventualmente já vinculados ao plano estipulado.
    </p>

    <h3
      class="titulo text-justify bold-preto-700 mt-2 font-italic"
      style="background: black; padding: 0.5rem; border-radius: 10px; color: #fff">
      Para informar-se sobre estes e outros detalhes da contratação de planos de saúde, o beneficiário deve contatar a
      operadora. Permanecendo dúvidas, pode consultar a ANS pelo site www.ans.gov.br ou pelo Disque - ANS
      (0800-701-9656).
      <h4 class="subtitulo text-center" style="color: #fff">ESTE MANUAL NÃO SUBSTITUI O CONTRATO</h4>
    </h3>
    <p class="alinhamento-texto-mobile">
      O Manual de Orientação para Contratação de Planos de Saúde é uma exigência da Resolução Normativa nº195/2009, da
      Agência Nacional de Saúde Suplementar.
    </p>
    <div class="logo-rodape">
      <img src="../../../../../../assets/app-assets/images/logos-empresas/logo-rodapede-documento.png" />
    </div>
    <div class="row col-12 texto-rodade rodape-sem-quebra">
      <div class="dashed-line"></div>

      <div class="col-md-6 text-center">
        <p>Agencia Nacional de Saúde Suplementar</p>
        <p>(ANS) Av. Augusto Severo, 84 - Glória | CEP:200021-040 Rio de Janeiro - RJ</p>
      </div>

      <div class="col-md-6 text-center">
        <p>Disque-ANS: 0800 701 9656 www.ans.gov.br | ouvidoria@ans.gov.br</p>
      </div>

      <div class="dashed-line"></div>
    </div>
  </div>
</section>
